import { render } from "./SlidesPage.vue?vue&type=template&id=efeddb5c&scoped=true"
import script from "./SlidesPage.vue?vue&type=script&lang=js"
export * from "./SlidesPage.vue?vue&type=script&lang=js"
script.render = render
script.__scopeId = "data-v-efeddb5c"

export default script